import React from "react";
import { Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Paypal from "components/PayPal";
import PayInfo from "views/Productos/Sections/PayInfo";
import { sendAfinazoneEmail, sendClientEmail } from "utils/EmailSender/EmailSender";
import { createOrder } from "utils/LaravelApi/LaravelAPI";

const formatDateToDDMMYYYYHHMM = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
};

const createProducts = (items) => {
    return items.map((item) => ({
        quantity: item.amount,
        description: item.description,
        name: item.title,
        category: item.category,
        id: item.id,
        price: item.discount ? item.discountPrice : item.price,
    }));
};

const sendEmails = async (clientData, products) => {
    const emailStatus = await sendClientEmail(clientData, products);
    const emailAfinazone = await sendAfinazoneEmail(clientData, products);

    if (emailStatus.success && emailAfinazone.success) {
        alert("Email enviado correctamente, revisar spam.");
    } else {
        console.log(emailStatus);
        alert("No pudo enviarse el email.");
    }
};

const createSellOrder = async ({
    items,
    name,
    email,
    street,
    postalCode,
    colony,
    city,
    state,
    country,
    phone,
    addressReference,
    metodo_pago,
}) => {
    const date = formatDateToDDMMYYYYHHMM();
    const products = createProducts(items);

    const orderData = {
        realDate: new Date(),
        date,
        name,
        email,
        street,
        postalCode,
        colony,
        city,
        state,
        country,
        phone,
        referenceAddress: addressReference,
        status: "En preparación",
        products,
        metodo_pago,
    };

    const createOrderResponse = await createOrder(orderData);

    if (createOrderResponse.status === 201) {
        alert("Orden creada correctamente");

        const clientData = {
            name,
            street,
            reference: addressReference,
            neighbor: colony,
            postal_code: postalCode,
            city,
            state,
            phone,
            email,
            country: `${window.location.origin}/pedido/${createOrderResponse?.data?.order?.uuid}`,
            pedido: createOrderResponse?.data?.order?.id,
        };

        await sendEmails(clientData, products);
    } else {
        alert("Orden pagada pero no creada, contactar a soporte para envío correcto.");
    }

};


export default function Pago({ items, price, saving, updateSection, formData }) {


    const paybutton = {
        width: "40%",
    };
    const payinfo = {
        width: "60%",
    };

    const paybuttonMobile = {
        width: "100%",
    };

    const payinfoMobile = {
        width: "100%",
    };
    return (
        <Box
            sx={{
                paddingLeft: "10%",
                paddingRight: "10%",
                paddingTop: { xs: "30px", sm: "100px" },
                fontSize: { xs: "22px", sm: "40px" },
                textAlign: "center",
                fontWeight: { xs: "700", sm: "500" },
                fontFamily: "Nunito Sans, sans-serif",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <Box
                component={ArrowBackIcon}
                sx={{
                    fontSize: { xs: "25px", sm: "40px" },
                    fontWeight: "900",
                    cursor: "pointer",
                    position: "absolute",
                    left: "10%", // Posición relativa al contenedor
                    top: { xs: "32px", sm: "110px" },
                }}
                onClick={() => updateSection('formularioSection')}
            />
            <Box
                sx={{
                    textAlign: "center",
                    marginBottom: "10px",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                }}
            >
                Finalizar Compra
            </Box>
            <hr style={{ width: "100%", borderColor: "#ccc" }} />
            <Box component="div" sx={{ display: { xs: "none", md: "flex" } }}>
                <div style={paybutton}>
                    <Paypal items={items} createSellOrder={(paymentSource) => createSellOrder({ metodo_pago: paymentSource, items, ...formData })} />
                </div>
                <div style={payinfo}>
                    <PayInfo items={items} price={price} saving={saving} />
                </div>
            </Box>
            <Box component="div" sx={{ display: { xs: "block", md: "none" } }}>
                <div style={payinfoMobile}>
                    <PayInfo items={items} price={price} />
                </div>
                <div style={paybuttonMobile}>
                    <Paypal items={items} createSellOrder={(paymentSource) => createSellOrder({ metodo_pago: paymentSource, items, ...formData })} />
                </div>
            </Box>
        </Box>
    );
}
